import React, { useState } from 'react';
import './PaidInfo.css';

const PaidInfo = ({ paidBy, paidAt }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('es-CO') + ' ' + date.toLocaleTimeString('es-CO');
  };

  if (!paidBy) return null;

  return (
    <div className="paid-info-container">
      <button
        className="paid-info-btn"
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        onClick={() => setShowTooltip(!showTooltip)}
        title="Información de pago"
      >
        👁️
      </button>
      
      {showTooltip && (
        <div className="paid-tooltip">
          <div className="tooltip-content">
            <div className="tooltip-item">
              <span className="tooltip-label">Pagado por:</span>
              <span className="tooltip-value">{paidBy}</span>
            </div>
            <div className="tooltip-item">
              <span className="tooltip-label">Fecha:</span>
              <span className="tooltip-value">{formatDate(paidAt)}</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PaidInfo;
